import handleClick from '../../../../../../../../../utils/handleClick';
import computeClassName from "../../../../../../../../../utils/computeClassName";

const constants = Object.freeze({
  CLASSNAME_BASE : 'flex items-center overflow-hidden py-4 font-normal text-cc-primary-contrast',
  CLASSNAME_IS_FIRST: {
    true: 'px-6 xs:px-14',
    false: 'px-4 xs:px-6'
  },
  CLASSNAME_IS_SELECTED: {
    true: 'bg-cc-white font-semibold',
    false: 'bg-cc-gray-0 shadow-pf-form-tab'
  }
});

const propsDefaults = Object.freeze({
  isSelected: false,
  isFirst: false,
  selectFn: null,
  selectFnArgs: undefined
});

function getComputedClassName(propsClassName, isSelected, isFirst) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_SELECTED[isSelected]} ${constants.CLASSNAME_IS_FIRST[isFirst]}`);
}

function computeHandleClickFn(selectFn, selectFnArgs) {
  return (e) => {
    e.preventDefault();
    handleClick(selectFn, selectFnArgs)();
  }
}

export default function FormTabsTab(
  {
    isSelected = propsDefaults.isSelected,
    isFirst = propsDefaults.isFirst,
    selectFn = propsDefaults.selectFn,
    selectFnArgs = propsDefaults.selectFnArgs,
    children,
    className = ''
  }
  ) {
  const computedClassName = getComputedClassName(className, isSelected, isFirst);
  const computedHandleClickFn = computeHandleClickFn(selectFn, selectFnArgs);
  return (
    isSelected ?
      (
        <li className={computedClassName}>{children}</li>
      ) :
      (
        <li className={className}>
          <a href="/" className={computedClassName} onClick={computedHandleClickFn}>{children}</a>
        </li>
      )
  );
}
